import React from 'react';
import Info from 'components/VideoLive/Info';
import { ScheduleLive } from 'components/VideoLive/ScheduleLive';
import Banner from 'components/VideoLive/Banner';
import { OmegaVideoPlayer } from 'components/OmegaVideoPlayer';
import { STREAM_KEYS } from 'lib/liveVideo';
import { package as PackagePropType } from 'lib/CustomPropTypes';
import NDPVideo from '../LiveVideoEmbed/NDPVideo';
import 'assets/styles/main.scss';
import 'assets/styles/toolkit.scss';
import './styles.themed.scss';

/**
 *
 * @param {object} props
 */
const LiveVideo = (props) => {
  const { content } = props;
  const { vertical } = content.context;

  const verticalCvsdkKeyMap = {
    news: STREAM_KEYS.NEWS_NOW,
    today: STREAM_KEYS.TODAY_ALL_DAY,
    MSNBC: STREAM_KEYS.MSNBC_TVE,
    noticias: STREAM_KEYS.NOTICIAS_AHORA,
    telemundo: STREAM_KEYS.TELEMUNDO_AL_DIA,
    deportes: STREAM_KEYS.TELEMUNDO_DEPORTES_AHORA,
  };

  const cvsdkKey = verticalCvsdkKeyMap[vertical];

  const {
    items: [item],
  } = content;

  const packageMetadata = (content?.metadata) || {};
  const isLinearVideo = packageMetadata?.playmakerToggle ?? true;

  return (
    <>
      <section className="video-live">
        <div className="layout-grid-container">
          <div className="video-live__inner">
            <div className="video-live__stage">
              {isLinearVideo ? (
                <div className="video-live__core-video-container">
                  <OmegaVideoPlayer
                    stream={cvsdkKey}
                    autoplay
                    mutedAutoplay
                    stickyEnabled
                  />
                </div>
              ) : (
                <NDPVideo item={item} isRail={false} />
              )}

              <div className="video-live__info-container">
                <Info />
              </div>
            </div>

            <div className="video-live__schedule-container">
              <ScheduleLive />
            </div>
          </div>
        </div>

        <Banner />
      </section>
    </>
  );
};

LiveVideo.propTypes = {
  content: PackagePropType.isRequired,
};

export { LiveVideo };
